import React,{useState} from 'react';
import {motion} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import './ConnectionsScreen.css';

const {
  FiCheck,
  FiFacebook,
  FiInstagram,
  FiLinkedin,
  FiMusic,
  FiSettings,
  FiX
}=FiIcons;

const platforms=[
  {id:'instagram',name:'Instagram',icon:FiInstagram},
  {id:'facebook',name:'Facebook',icon:FiFacebook},
  {id:'linkedin',name:'LinkedIn',icon:FiLinkedin},
  {id:'tiktok',name:'TikTok',icon:FiMusic}
];

function createHandle(brandName) {
  const slug=brandName.toLowerCase().replace(/[^a-z0-9]/g,'');
  return `@${slug || 'brand'}`;
}

function PlatformRow({platform,connection,brand,onChange}) {
  const [confirming,setConfirming]=useState(false);

  const connect=()=> {
    onChange(platform.id,{
      connected:true,
      handle:createHandle(brand.name)
    });
  };

  const disconnect=()=> {
    onChange(platform.id,{connected:false,handle:null});
    setConfirming(false);
  };

  return (
    <motion.article
      className={`connection-row ${connection.connected ? 'connected' : ''}`}
      layout
      transition={{duration:0.18}}
    >
      <span className="platform-icon">
        <SafeIcon icon={platform.icon} />
      </span>

      <div className="platform-details">
        <h2>{platform.name}</h2>
        {connection.connected ? (
          <div className="connection-status connected-status">
            <i style={{background:brand.accent}} />
            <span>Connected</span>
            <strong>{connection.handle}</strong>
          </div>
        ) : (
          <div className="connection-status">
            <i />
            <span>Not connected</span>
          </div>
        )}
      </div>

      <div className="connection-actions">
        {!connection.connected && (
          <button
            className="connection-primary"
            style={{background:brand.primary}}
            onClick={connect}
          >
            Connect
          </button>
        )}

        {connection.connected && !confirming && (
          <button
            className="disconnect-button"
            onClick={()=> setConfirming(true)}
          >
            Disconnect
          </button>
        )}

        {connection.connected && confirming && (
          <div className="disconnect-confirm">
            <span>Disconnect?</span>
            <button
              className="confirm-disconnect"
              onClick={disconnect}
              aria-label={`Confirm disconnecting ${platform.name}`}
            >
              <SafeIcon icon={FiCheck} />
            </button>
            <button
              onClick={()=> setConfirming(false)}
              aria-label="Cancel disconnect"
            >
              <SafeIcon icon={FiX} />
            </button>
          </div>
        )}
      </div>
    </motion.article>
  );
}

function ConnectionsScreen({brand,connections,loading,error,onChange}) {
  const connectedCount=platforms.filter(
    (platform)=> connections[platform.id]?.connected
  ).length;

  return (
    <motion.main
      className="page connections-page"
      initial={{opacity:0}}
      animate={{opacity:1}}
    >
      <header className="connections-header">
        <div>
          <span className="eyebrow">{brand.name}</span>
          <h1>Connections</h1>
          <p>
            Link the social accounts this brand will eventually publish to.
          </p>
        </div>
        <div className="connections-mark">
          <SafeIcon icon={FiSettings} />
        </div>
      </header>

      {error && (
        <p className="connections-error" role="alert">{error}</p>
      )}

      <section className="connections-panel">
        <div className="connections-summary">
          <div>
            <span className="eyebrow">Social accounts</span>
            <h2>Publishing destinations</h2>
          </div>
          <span className="connection-count">
            {connectedCount} of {platforms.length} connected
          </span>
        </div>

        {loading ? (
          <p className="connections-loading">Loading connections…</p>
        ) : (
        <div className="connections-list">
          {platforms.map((platform)=> (
            <PlatformRow
              key={platform.id}
              platform={platform}
              connection={connections[platform.id]}
              brand={brand}
              onChange={onChange}
            />
          ))}
        </div>
        )}
      </section>

      <p className="connections-note">
        Connections are simulated for this frontend preview. No account
        credentials or platform data are exchanged.
      </p>
    </motion.main>
  );
}

export default ConnectionsScreen;